module.exports = __webpack_public_path__ + "img/card2.e0e5e43c.png";